import * as _ from 'lodash-es';

export interface AlphabetFilterable {
    alphabetFilterOn: string[];
}

export class SearchFilter<T extends any> {

    private _letter: string;
    private _searchText: string;
    private _array: (AlphabetFilterable & T)[];
    private _filteredArray: (AlphabetFilterable & T)[];

    public caseSensitive: boolean;
    public oneOrTheOther: boolean;

    // Override methods for the default filter() method,
    // in case a BE call needs to be executed instead
    public usesBackendForFiltering: boolean;
    public onLetterChangeCallBackFn: () => void;
    public onTextChangeCallBackFn: () => void;

    get letter() {
        return this._letter;
    }

    set letter(letter: string) {
        this._letter = this._letter !== letter ? letter : null;

        if (this.oneOrTheOther) {
            this._searchText = null;
        }

        this.onLetterChangeCallBackFn ? this.onLetterChangeCallBackFn() : this.filter();
    }

    get searchText() {
        return this._searchText;
    }

    set searchText(searchText: string) {
        this._searchText = searchText;

        if (this.oneOrTheOther) {
            this._letter = null;
        }

        this.onTextChangeCallBackFn ? this.onTextChangeCallBackFn() : this.filter();
    }

    set array(array: (AlphabetFilterable & T)[]) {
        this._array = array;
        this.filter();
    }

    get filteredArray(): (AlphabetFilterable & T)[] {
        return this._filteredArray;
    }

    constructor(caseSensitive: boolean,
                oneOrTheOther: boolean,
                usesBackendForFiltering?: boolean,
                onLetterChangeCallBackFn?: () => void,
                onTextChangeCallBackFn?: () => void) {
        this.caseSensitive = caseSensitive;
        this.oneOrTheOther = oneOrTheOther;
        this.usesBackendForFiltering = usesBackendForFiltering;
        this.onLetterChangeCallBackFn = onLetterChangeCallBackFn;
        this.onTextChangeCallBackFn = onTextChangeCallBackFn;
    }

    public filter(): void {
        if (this._array) {
            if (!this.usesBackendForFiltering && (this._letter || this._searchText)) {
                this._filteredArray = this._array.filter((item: AlphabetFilterable & T) => {
                    const filterTexts = this.caseSensitive ? item.alphabetFilterOn : item.alphabetFilterOn.map(text => text.toLowerCase());
                    let keep = false;

                    if (filterTexts) {
                        _.each(filterTexts, text => {
                            if (this.letter) {
                                const lowerCaseLetter = this.letter.toLowerCase();
                                keep = _.startsWith(text, this.letter) || _.startsWith(text, lowerCaseLetter);

                                if (keep) {
                                    return false; //  = BREAK THE LOOP
                                }
                            }

                            if (this.searchText) {
                                const sensitive = this.caseSensitive ? this.searchText : this.searchText.toLowerCase();
                                keep = _.includes(text, sensitive);

                                if (keep) {
                                    return false; //  = BREAK THE LOOP
                                }
                            }
                        });
                    } else {
                        keep =  false;
                    }

                    return keep;
                });
            } else {
                this._filteredArray = this._array.slice();
            }
        } else {
            this._filteredArray = null;
        }
    }
}
